import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { ForgotPasswordComponent } from './forgot-password.component';

const MaterialModules = [MatCardModule, MatInputModule, MatButtonModule, MatProgressSpinnerModule];

@NgModule({
  imports: [
    MaterialModules,
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: ForgotPasswordComponent,
      },
    ]),
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    GalaxyInputModule,
  ],
  declarations: [ForgotPasswordComponent],
  providers: [],
})
export class ForgotPasswordModule {}
